import Vue from 'vue';
import Router from 'vue-router';
import beforEach from './beforeEach';
//-- --------- LAYOUT --------- --//
import FullLayout from '@/containers/Full';
//-- --------- DEBUG --------- --//
import DebugRoutes from '@/views/Debug/Routes/Routes';
//-- --------- AUTH --------- --//
import AuthLogin from '@/views/Auth/Login';
import AuthRegister from '@/views/Auth/Register';
import AuthRegisterTenant from '@/views/Auth/RegisterTenant';
import AuthRegisterTenantDone from '@/views/Auth/RegisterTenantDone';
import PasswordEmail from '@/views/Auth/PasswordEmail';
import PasswordReset from '@/views/Auth/PasswordReset';
//-- --------- DASHBOARD --------- --//
const Dashboard =
    () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard');
//-- --------- CONTACTS - CONTACT --------- --//
const ContactsContactIndex =
    () => import(/* webpackChunkName: "contact" */ '@/views/Contacts/Contact/Index');
const ContactsContactCreate =
    () => import(/* webpackChunkName: "contact" */ '@/views/Contacts/Contact/Create');
const ContactsContactGroupMembers =
    () => import(/* webpackChunkName: "contact" */ '@/views/Contacts/Contact/GroupMembers');
const ContactsContactShow =
    () => import(/* webpackChunkName: "contact" */ '@/views/Contacts/Contact/Show');
const ContactsContactView =
    () => import(/* webpackChunkName: "contact" */ '@/views/Contacts/Contact/View');
const ContactsContactEdit =
    () => import(/* webpackChunkName: "contact" */ '@/views/Contacts/Contact/Edit');
const ContactsContactEditLogin =
    () => import(/* webpackChunkName: "contact" */ '@/views/Contacts/Contact/EditLogin');
const ContactsContactSendNewPassword =
    () => import(/* webpackChunkName: "contact" */ '@/views/Contacts/Contact/SendNewPassword');
//-- --------- CONTACTS - CONTACT - TABS --------- --//
const ContactsContactDetailsTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/DetailTab');
const ContactsContactAddressesTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/AddressTab');
const ContactsContactPhonesTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/PhoneTab');
const ContactsContactEmailsTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/EmailTab');
const ContactsContactLoginDataTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/LoginDataTab');
const ContactsContactStaffMemberTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/StaffMemberTab');
const ContactsContactGroupMemberTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/GroupMemberTab');
const ContactsContactGroupsTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/GroupsTab');
const ContactsContactSettingTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/SettingTab');
const ContactsContactAbsencesTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/AbsencesTab');
const ContactsContactPendingVacationsTab =
    () => import(/* webpackChunkName: "contact-tabs" */ '@/views/Contacts/Contact/Partials/Show/PendingVacationsTab');
//-- --------- CONTACTS - CONTACT - TABS - SETTINGS --------- --//
const ContactsContactWidgetsTab =
    () => import(/* webpackChunkName: "contact-settings" */
        '@/views/Contacts/Contact/Partials/Show/Settings/WidgetTab');
const ContactsContactAccountingTab =
    () => import(/* webpackChunkName: "contact-settings" */
        '@/views/Contacts/Contact/Partials/Show/Settings/AccountingTab');
const ContactsContactStatusInformationTab =
    () => import(/* webpackChunkName: "contact-settings" */
        '@/views/Contacts/Contact/Partials/Show/Settings/StatusInformationTab');
const ContactsContactOvertimeTab =
    () => import(/* webpackChunkName: "contact-settings" */
        '@/views/Contacts/Contact/Partials/Show/Settings/OvertimeTab');
//-- --------- CONTACTS - ADDRESS --------- --//
const ContactsAddressCreate =
    () => import(/* webpackChunkName: "contact-address" */ '@/views/Contacts/Address/Create');
const ContactsAddressEdit =
    () => import(/* webpackChunkName: "contact-address" */ '@/views/Contacts/Address/Edit');
//-- --------- CONTACTS - PHONE --------- --//
const ContactsPhoneCreate =
    () => import(/* webpackChunkName: "contact-phone" */ '@/views/Contacts/Phone/Create');
const ContactsPhoneEdit =
    () => import(/* webpackChunkName: "contact-phone" */ '@/views/Contacts/Phone/Edit');
//-- --------- CONTACTS - EMAIL --------- --//
const ContactsEmailCreate =
    () => import(/* webpackChunkName: "contact-email" */ '@/views/Contacts/Email/Create');
const ContactsEmailEdit =
    () => import(/* webpackChunkName: "contact-email" */ '@/views/Contacts/Email/Edit');
//-- --------- CONTACTS - INVITE USER --------- --//
const ContactsInviteUser =
    () => import(/* webpackChunkName: "contact-invite" */ '@/views/Contacts/Contact/InviteUser');
//-- --------- CONTACTS - ADDITIONAL OVERTIME --------- --//
const ContactsOvertimeCreate =
    () => import(/* webpackChunkName: "contact-overtime" */ '@/views/Contacts/Overtime/Create');
const ContactsOvertimeEdit =
    () => import(/* webpackChunkName: "contact-overtime" */ '@/views/Contacts/Overtime/Edit');
//-- --------- ABSENCES --------- --//
const AbsencesIndex =
    () => import(/* webpackChunkName: "absences" */ '@/views/Absences/Index');
const AbsencesAbsenceCreate =
    () => import(/* webpackChunkName: "absences" */ '@/views/Absences/Create');
const AbsencesAbsenceEdit =
    () => import(/* webpackChunkName: "absences" */ '@/views/Absences/Edit');
const AbsencesEditVacationEntitlement =
    () => import(/* webpackChunkName: "absences" */ '@/views/Absences/EditVacationEntitlement');
const AbsencesPendingVacationsRedirect =
    () => import(/* webpackChunkName: "absences" */ '@/views/Absences/PendingVacationsRedirect');
//-- --------- NOTIFICATION SETTINGS --------- --//
const EmergencyNotificationSettings =
    () => import(/* webpackChunkName: "notifications" */ '@/views/Notification/Emergency');
const SlaIndex =
    () => import(/* webpackChunkName: "notifications" */ '@/views/Notification/ServiceLevelAgreement');
const SlaConfiguration =
    () => import(/* webpackChunkName: "notifications" */ '@/views/Notification/SlaConfiguration');
const SlaConfigurationCreate =
    () => import(/* webpackChunkName: "notifications" */ '@/views/Notification/Create');
const SlaConfigurationEdit =
    () => import(/* webpackChunkName: "notifications" */ '@/views/Notification/Edit');
const SlaConfigurationShow =
    () => import(/* webpackChunkName: "notifications" */ '@/views/Notification/Show');
const SlaSettings =
    () => import(/* webpackChunkName: "notifications" */ '@/views/Notification/SlaSettings');
const SlaDateView =
    () => import(/* webpackChunkName: "notifications" */ '@/views/Notification/SlaDateView');
const SlaAdditionalShiftStaff =
    () => import(/* webpackChunkName: "notifications" */ '@/views/Notification/SlaAdditionalShiftStaff');
//-- --------- ADMIN - ROLES --------- --//
const AdminRolesIndex =
    () => import(/* webpackChunkName: "admin-roles" */ '@/views/Admin/Roles/Index');
const AdminRolesRoleShow =
    () => import(/* webpackChunkName: "admin-roles" */ '@/views/Admin/Roles/Show');
const AdminRolesRoleCreate =
    () => import(/* webpackChunkName: "admin-roles" */ '@/views/Admin/Roles/Create');
const AdminRolesRoleEdit =
    () => import(/* webpackChunkName: "admin-roles" */ '@/views/Admin/Roles/Edit');
//-- --------- ADMIN - CONTACT SETTINGS --------- --//
const AdminContactSettings =
    () => import(/* webpackChunkName: "admin-contact-settings" */ '@/views/Admin/Contact/Settings');
//-- --------- ADMIN - SYSTEM SETTINGS --------- --//
const AdminSystemSettings =
    () => import(/* webpackChunkName: "admin-system-settings" */ '@/views/Admin/System/Settings');
const AdminSystemSettingsHolidays =
    () => import(/* webpackChunkName: "admin-system-settings" */ '@/views/Admin/System/PublicHolidays');
const AdminSystemSettingsHolidayCreate =
    () => import(/* webpackChunkName: "admin-system-settings" */ '@/views/Admin/System/CreateHoliday');
const AdminSystemSettingsHolidayEdit =
    () => import(/* webpackChunkName: "admin-system-settings" */ '@/views/Admin/System/EditHoliday');
const AdminSystemSettingsMaintenance =
    () => import(/* webpackChunkName: "admin-system-settings" */ '@/views/Admin/System/Maintenance');
//-- --------- ADMIN - WORKFLOW / TASK TRANSITION --------- --//
const TaskSettingsIndex =
    () => import(/* webpackChunkName: "admin-task-settings" */ '@/views/Admin/TaskSettings/Workflow/Index');
const TaskSettingsEdit =
    () => import(/* webpackChunkName: "admin-task-settings" */ '@/views/Admin/TaskSettings/Workflow/Edit');
const TaskSettingsCreate =
    () => import(/* webpackChunkName: "admin-task-settings" */ '@/views/Admin/TaskSettings/Workflow/Create');
const TaskTypeEdit =
    () => import(/* webpackChunkName: "admin-task-settings" */ '@/views/Admin/TaskSettings/Type/Edit');
const TaskTypeCreate =
    () => import(/* webpackChunkName: "admin-task-settings" */ '@/views/Admin/TaskSettings/Type/Create');
//-- --------- ADMIN - RMA SETTINGS --------- --//
const RmaSettingsIndex =
    () => import(/* webpackChunkName: "rma-settings" */ '@/views/Admin/Rma/Index');
const RmaSettingsHardwareTypeCreate =
    () => import(/* webpackChunkName: "rma-settings" */ '@/views/Admin/Rma/CreateHardwareType');
const RmaSettingsHardwareTypeEdit =
    () => import(/* webpackChunkName: "rma-settings" */ '@/views/Admin/Rma/EditHardwareType');
//-- --------- ADMIN - PROJECT SETTINGS --------- --//
const AdminProjectSettings =
    () => import(/* webpackChunkName: "admin-project-settings" */ '@/views/Admin/Project/Settings');
//-- --------- ADMIN - GLOBAL NOTIFICATIONS --------- --//
const GlobalNotificationsIndex =
    () => import(/* webpackChunkName: "admin-global-notifications" */ '@/views/Admin/GlobalNotifications/Index');
const GlobalNotificationsCreate =
    () => import(/* webpackChunkName: "admin-global-notifications" */ '@/views/Admin/GlobalNotifications/Create');
const GlobalNotificationsEdit =
    () => import(/* webpackChunkName: "admin-global-notifications" */ '@/views/Admin/GlobalNotifications/Edit');
//-- --------- ADMIN - TENANT SYSTEMS --------- --//
const TenantSystemsIndex =
    () => import(/* webpackChunkName: "admin-tenant-systems" */ '@/views/Admin/TenantSystems/Index');
//-- --------- ADMIN - TRANSLATIONS --------- --//
const TranslationsModelIndex =
    () => import(/* webpackChunkName: "admin-translations" */ '@/views/Admin/Translations/Models/Index');
const TranslationsModelEdit =
    () => import(/* webpackChunkName: "admin-translations" */ '@/views/Admin/Translations/Models/Edit');
//-- --------- ADMIN - TENANTS --------- --//
const TenantsIndex =
    () => import(/* webpackChunkName: "admin-tenants" */ '@/views/Admin/Tenants/Index');
const TenantsInvite =
    () => import(/* webpackChunkName: "admin-tenants" */ '@/views/Admin/Tenants/Invite');
const TenantsCreate =
    () => import(/* webpackChunkName: "admin-tenants" */ '@/views/Admin/Tenants/Create');
//-- --------- PROJECTS - PROJECT --------- --//
const ProjectsProjectIndex =
    () => import(/* webpackChunkName: "project" */ '@/views/Projects/Index');
const ProjectsProjectCreate =
    () => import(/* webpackChunkName: "project" */ '@/views/Projects/Create');
const ProjectsProjectEdit =
    () => import(/* webpackChunkName: "project" */ '@/views/Projects/Edit');
const ProjectsProjectShow =
    () => import(/* webpackChunkName: "project" */ '@/views/Projects/Show');
const ProjectAddInvitedUserToProject =
    () => import(/* webpackChunkName: "project" */ '@/views/Projects/AddInvitedUserToProject');
//-- --------- PROJECTS - PROJECT - TABS --------- --//
const ProjectsProjectDetailTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/DetailTab');
const ProjectsProjectAdditionalDetailTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/AdditionalDetailTab');
const ProjectsProjectTaskTypeConfigurationTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/TaskTypeConfigurationTab');
const ProjectsProjectManageBudgetTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/ManageBudgetTab');
const ProjectsProjectManageBudgetSupplierTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/ManageBudgetSupplierTab');
const MovableWorklogsTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/MovableWorklogsTab');
const ProjectsProjectVersionTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/VersionTab');
const ProjectsProjectFileTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/FileTab');
const ProjectsProjectWatcherTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/WatcherTab');
const ProjectsProjectExternalCostTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/ExternalCostTab');
const ProjectsProjectEarningsAndCostsTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/EarningsAndCostsTab');
const ProjectsProjectPlannedInternalExternalCostsTab =
    () => import(/* webpackChunkName: "project-tabs" */
        '@/views/Projects/Partials/Show/PlannedInternalExternalCostsTab');
const ProjectsProjectPlannedEarningsAndCostsTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/PlannedEarningsAndCostsTab');
const ProjectsProjectTagTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/TagTab');
const ProjectsProjectHistoryTab =
    () => import(/* webpackChunkName: "project-tabs" */ '@/views/Projects/Partials/Show/HistoryTab');
//-- --------- PROJECTS - PROJECT VERSION --------- --//
const ProjectsVersionCreate =
    () => import(/* webpackChunkName: "project-versions" */ '@/views/Projects/Versions/Create');
const ProjectsVersionRelease =
    () => import(/* webpackChunkName: "project-versions" */ '@/views/Projects/Versions/Release');
//-- --------- PROJECT - PROJECT FILES --------- --//
const ProjectFileCreate =
    () => import(/* webpackChunkName: "project-files" */ '@/views/Projects/Files/Create');
//-- --------- PROJECTS - EXTERNAL COSTS --------- --//
const ProjectsExternalCostCreate =
    () => import(/* webpackChunkName: "project-external-costs" */ '@/views/Projects/ExternalCosts/Create');
const ProjectsExternalCostCreatePlanned =
    () => import(/* webpackChunkName: "project-external-costs" */ '@/views/Projects/ExternalCosts/CreatePlanned');
const ProjectsExternalCostEdit =
    () => import(/* webpackChunkName: "project-external-costs" */ '@/views/Projects/ExternalCosts/Edit');
const ProjectsExternalCostEditPlanned =
    () => import(/* webpackChunkName: "project-external-costs" */ '@/views/Projects/ExternalCosts/EditPlanned');
//-- --------- PROJECTS - INTERNAL COSTS --------- --//
const ProjectsPlannedInternalCostCreate =
    () => import(/* webpackChunkName: "project-internal-costs" */ '@/views/Projects/PlannedInternalCosts/Create');
const ProjectsPlannedInternalCostEdit =
    () => import(/* webpackChunkName: "project-internal-costs" */ '@/views/Projects/PlannedInternalCosts/Edit');
//-- --------- PROJECTS - TASK TYPE CONFIGURATION --------- --//
const ProjectsTaskTypeConfigurationCreate =
    () => import(/* webpackChunkName: "project-task-type-config" */ '@/views/Projects/TaskTypeConfigurations/Create');
//-- --------- PROJECT PLANNING --------- --//
const ProjectPlanningIndex =
    () => import(/* webpackChunkName: "project-planning" */ '@/views/ProjectPlanning/Index');
const ProjectPlanningShow =
    () => import(/* webpackChunkName: "project-planning" */ '@/views/ProjectPlanning/Show');
//-- --------- WORKLOAD PLANNING --------- --//
const WorkloadPlanningIndex =
    () => import(/* webpackChunkName: "workload-planning" */ '@/views/WorkloadPlanning/Index');
const WorkloadPlanningShow =
    () => import(/* webpackChunkName: "workload-planning" */ '@/views/WorkloadPlanning/Show');
//-- --------- DOCUMENTS --------- --//
const DocumentsIndex =
    () => import(/* webpackChunkName: "documents" */ '@/views/Documents/Index');
const DocumentCreate =
    () => import(/* webpackChunkName: "documents" */ '@/views/Documents/Create');
const DocumentCreateVersion =
    () => import(/* webpackChunkName: "documents" */ '@/views/Documents/CreateVersion');
//-- --------- TASKS - TASK --------- --//
const TasksTaskIndex =
    () => import(/* webpackChunkName: "task-index" */ '@/views/Tasks/Task/Index');
const TasksTaskCreate =
    () => import(/* webpackChunkName: "tasks-form" */ '@/views/Tasks/Task/Create');
const TasksTaskCreateAnother =
    () => import(/* webpackChunkName: "tasks-form" */ '@/views/Tasks/Task/CreateAnother');
const TasksTaskShow =
    () => import(/* webpackChunkName: "tasks-show" */ '@/views/Tasks/Task/Show');
const TasksTaskEdit =
    () => import(/* webpackChunkName: "tasks-form" */ '@/views/Tasks/Task/Edit');
//-- --------- RMA - RMA --------- --//
const RmaIndex =
    () => import(/* webpackChunkName: "rma-index" */ '@/views/Rma/Index');
const RmaCreate =
    () => import(/* webpackChunkName: "rma-create" */ '@/views/Rma/Create');
const RmaShow =
    () => import(/* webpackChunkName: "rma-show" */ '@/views/Rma/Show');
const RmaEdit =
    () => import(/* webpackChunkName: "rma-edit" */ '@/views/Rma/Edit');
//-- --------- DUTIES - DUTY --------- --//
const Duty =
    () => import(/* webpackChunkName: "duties" */ '@/views/Duties/Index');
const DutyCreate =
    () => import(/* webpackChunkName: "duties" */ '@/views/Duties/Duty/Create');
const DutyShare =
    () => import(/* webpackChunkName: "duties" */ '@/views/Duties/Duty/Share');
//-- --------- REPORTS - TIME TRACKING --------- --//
const TimeTrackingConfig =
    () => import(/* webpackChunkName: "reports-time-tracking" */ '@/views/Reports/TimeTracking/Config');
const TimeTrackingReport =
    () => import(/* webpackChunkName: "reports-time-tracking" */ '@/views/Reports/TimeTracking/Report');
//-- --------- REPORTS - TASK FEEDBACK --------- --//
const TaskFeedbackConfig =
    () => import(/* webpackChunkName: "reports-feedback" */ '@/views/Reports/TaskFeedback/Config');
const TaskFeedbackReport =
    () => import(/* webpackChunkName: "reports-feedback" */ '@/views/Reports/TaskFeedback/Report');
//-- --------- REPORTS - RELEASE PREPARATION --------- --//
const ReleasePreparationConfig =
    () => import(/* webpackChunkName: "reports-release-preparation" */ '@/views/Reports/ReleasePreparation/Config');
const ReleasePreparationReport =
    () => import(/* webpackChunkName: "reports-release-preparation" */ '@/views/Reports/ReleasePreparation/Report');
//-- --------- REPORTS - TASK DISTRIBUTION --------- --//
const TaskDistributionConfig =
    () => import(/* webpackChunkName: "reports-task-distribution" */ '@/views/Reports/TaskDistribution/Config');
const TaskDistributionReport =
    () => import(/* webpackChunkName: "reports-task-distribution" */ '@/views/Reports/TaskDistribution/Report');
const TaskDistributionReportSettingsIndex =
    () => import(/* webpackChunkName: "reports-task-distribution" */
        '@/views/Reports/TaskDistribution/ReportSettings/Index');
const TaskDistributionReportSettingsCreate =
    () => import(/* webpackChunkName: "reports-task-distribution" */
        '@/views/Reports/TaskDistribution/ReportSettings/Create');
const TaskDistributionReportSettingsEdit =
    () => import(/* webpackChunkName: "reports-task-distribution" */
        '@/views/Reports/TaskDistribution/ReportSettings/Edit');
//-- --------- REPORTS - WORK REPORT --------- --//
const ProjectWorkReport =
    () => import(/* webpackChunkName: "reports-work-report" */ '@/views/Reports/WorkReport/ProjectReport');

const EmployeeWorkReport =
  () => import(/* webpackChunkName: "reports-work-report" */ '@/views/Reports/WorkReport/EmployeeReport');
//-- --------- REPORTS - RATIO REPORT --------- --//
const RatioReportConfig =
    () => import(/* webpackChunkName: "reports-ratio-report" */ '@/views/Reports/RatioReport/Config');
const RatioReportReport =
    () => import(/* webpackChunkName: "reports-ratio-report" */ '@/views/Reports/RatioReport/Report');
const RatioReportSettingsIndex =
    () => import(/* webpackChunkName: "reports-ratio-report" */ '@/views/Reports/RatioReport/ReportSettings/Index');
const RatioReportSettingsCreate =
    () => import(/* webpackChunkName: "reports-ratio-report" */ '@/views/Reports/RatioReport/ReportSettings/Create');
const RatioReportSettingsEdit =
    () => import(/* webpackChunkName: "reports-ratio-report" */ '@/views/Reports/RatioReport/ReportSettings/Edit');
//-- --------- ACCOUNTING - INVOICE PREPARATION --------- --//
const InvoicePreparationIndex =
    () => import(/* webpackChunkName: "invoice-preparation" */ '@/views/Accounting/InvoicePreparation/Index');
const InvoicePreparationCreate =
    () => import(/* webpackChunkName: "invoice-preparation" */ '@/views/Accounting/InvoicePreparation/Create');
const InvoicePreparationEdit =
    () => import(/* webpackChunkName: "invoice-preparation" */ '@/views/Accounting/InvoicePreparation/Edit');
const InvoicePreparationPreparedInvoices =
    () => import(/* webpackChunkName: "invoice-preparation" */
        '@/views/Accounting/InvoicePreparation/PreparedInvoices');
//-- --------- ACCOUNTING - INVOICE ISSUING --------- --//
const InvoiceIssuingIndex =
    () => import(/* webpackChunkName: "invoice-issuing" */ '@/views/Accounting/InvoiceIssuing/Index');
const InvoiceIssuingEdit =
    () => import(/* webpackChunkName: "invoice-issuing" */ '@/views/Accounting/InvoiceIssuing/Edit');
//-- --------- ACCOUNTING - INVOICE COMPLETION --------- --//
const InvoiceCompletionIndex =
    () => import(/* webpackChunkName: "invoice-completion" */ '@/views/Accounting/InvoiceCompletion/Index');
const InvoiceCompletionUploadOriginal =
    () => import(/* webpackChunkName: "invoice-completion" */ '@/views/Accounting/InvoiceCompletion/UploadOriginal');
const InvoiceCompletionCreate =
    () => import(/* webpackChunkName: "invoice-completion" */ '@/views/Accounting/InvoiceCompletion/Create');
const InvoiceCompletionEdit =
    () => import(/* webpackChunkName: "invoice-completion" */ '@/views/Accounting/InvoiceCompletion/Edit');
//-- --------- DOCUMENTATION --------- --//
const DocumentationsIndex =
    () => import(/* webpackChunkName: "documentation" */ '@/views/Documentations/Index');
const DocumentationsCreate =
    () => import(/* webpackChunkName: "documentation" */ '@/views/Documentations/Create');
//-- --------- CALENDAR --------- --//
const Calendar =
    () => import(/* webpackChunkName: "calendar" */ '@/views/Calendar/Calendar');
//-- --------- TELEPHONE LIST --------- --//
const TelephoneListIndex =
    () => import(/* webpackChunkName: "telephone-list" */ '@/views/TelephoneList/TelephoneList');
const TelephoneListHistory =
    () => import(/* webpackChunkName: "telephone-list" */ '@/views/TelephoneList/History');
const TelephoneListCreate =
    () => import(/* webpackChunkName: "telephone-list" */ '@/views/TelephoneList/Create');
const TelephoneListEdit =
    () => import(/* webpackChunkName: "telephone-list" */ '@/views/TelephoneList/Edit');

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior(to, from) {
        if (to.name === from.name && to.meta.keepScrollPosition) {
            return {};
        }

        return { y: 0 };
    },
    routes: [
        {
            path: '/login',
            name: 'auth.login',
            component: AuthLogin,
            meta: {
                forVisitors: true
            }
        },
        {
            path: '/register/:key/:hash',
            name: 'auth.register',
            component: AuthRegister,
            meta: {
                forVisitors: true
            }
        },
        {
            path: '/register-tenant/:key/:hash',
            name: 'auth.register-tenant',
            component: AuthRegisterTenant,
            meta: {
                forVisitors: true
            }
        },
        {
            path: '/register-tenant-done/:key/:hash',
            name: 'auth.register-tenant-done',
            component: AuthRegisterTenantDone,
            meta: {
                forVisitors: true
            }
        },
        {
            path: '/password/reset',
            name: 'password.email',
            component: PasswordEmail,
            meta: {
                forVisitors: true
            }
        },
        {
            path: '/password/reset/:token',
            name: 'password.reset',
            component: PasswordReset,
            meta: {
                forVisitors: true
            }
        },
        {
            path: '/',
            name: 'home',
            component: FullLayout,
            redirect: '/dashboard',
            children: [
                {
                    path: 'dashboard',
                    name: 'dashboard.index',
                    component: Dashboard
                }
            ]
        },
        {
            path: '/invited',
            name: 'projects.add-invited-user-to-project',
            component: FullLayout,
            children: [
                {
                    path: ':token',
                    name: 'invited.project',
                    props: true,
                    component: ProjectAddInvitedUserToProject
                }
            ]
        },
        {
            path: '/debug',
            name: 'debug',
            component: FullLayout,
            children: [
                {
                    path: 'routes',
                    name: 'debug.routes',
                    component: DebugRoutes
                }
            ]
        },
        {
            path: '/reports',
            component: FullLayout,
            children: [
                {
                    path: 'time-tracking/config',
                    name: 'reports.time-tracking.config',
                    component: TimeTrackingConfig,
                    meta: {
                        requiredAbility: 'reports.time_tracking'
                    },
                    props: (route) => ({
                        projectKey: route.query.project,
                        projectVersionKey: route.query.projectVersion,
                        tasksKey: route.query.tasks
                    })
                },
                {
                    path: 'time-tracking/report',
                    name: 'reports.time-tracking.report',
                    component: TimeTrackingReport,
                    meta: {
                        requiredAbility: 'reports.time_tracking'
                    },
                    props: (route) => ({
                        projectKey: route.query.project,
                        projectVersionKey: route.query.projectVersion,
                        tasksKey: route.query.tasks
                    })
                },
                {
                    path: 'task-feedback/config',
                    name: 'reports.task-feedback.config',
                    component: TaskFeedbackConfig,
                    meta: {
                        requiredAbility: 'reports.feedback'
                    },
                    props: (route) => ({
                        projectKey: route.query.project,
                        projectVersionKey: route.query.projectVersion,
                        tasksKey: route.query.tasks
                    })
                },
                {
                    path: 'task-feedback/report',
                    name: 'reports.task-feedback.report',
                    component: TaskFeedbackReport,
                    meta: {
                        requiredAbility: 'reports.feedback'
                    },
                    props: (route) => ({
                        projectKey: route.query.project,
                        projectVersionKey: route.query.projectVersion,
                        tasksKey: route.query.tasks
                    })
                },
                {
                    path: 'release-preparation/config',
                    name: 'reports.release-preparation.config',
                    component: ReleasePreparationConfig,
                    meta: {
                        requiredAbility: 'reports.release-preparation'
                    },
                    props: (route) => ({
                        projectKey: route.query.project,
                        projectVersionKey: route.query.projectVersion,
                        tasksKey: route.query.tasks
                    })
                },
                {
                    path: 'release-preparation/report',
                    name: 'reports.release-preparation.report',
                    component: ReleasePreparationReport,
                    meta: {
                        requiredAbility: 'reports.release-preparation'
                    },
                    props: (route) => ({
                        projectKey: route.query.project,
                        projectVersionKey: route.query.projectVersion,
                        tasksKey: route.query.tasks
                    })
                },
                {
                    path: 'task-distribution/config',
                    name: 'reports.task-distribution.config',
                    component: TaskDistributionConfig,
                    meta: {
                        requiredAbility: 'reports.task-distribution.view'
                    },
                    props: (route) => ({
                        projectKey: route.query.project,
                        reportType: route.query.report_type,
                        setting: route.query.setting,
                        dateStart: route.query.date_start,
                        dateEnd: route.query.date_end
                    })
                },
                {
                    path: 'task-distribution/report',
                    name: 'reports.task-distribution.report',
                    component: TaskDistributionReport,
                    meta: {
                        requiredAbility: 'reports.task-distribution.view'
                    },
                    props: (route) => ({
                        projectKey: route.query.project,
                        reportType: route.query.report_type,
                        setting: route.query.setting,
                        dateStart: route.query.date_start,
                        dateEnd: route.query.date_end
                    })
                },
                {
                    path: 'task-distribution/report-settings',
                    name: 'reports.task-distribution.report-settings.index',
                    meta: {
                        requiredAbility: 'reports.task-distribution.manage'
                    },
                    component: TaskDistributionReportSettingsIndex
                },
                {
                    path: 'task-distribution/report-settings/create',
                    name: 'reports.task-distribution.report-settings.create',
                    meta: {
                        requiredAbility: 'reports.task-distribution.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: TaskDistributionReportSettingsCreate
                },
                {
                    path: 'task-distribution/report-settings/:setting_key/edit',
                    name: 'reports.task-distribution.report-settings.edit',
                    meta: {
                        requiredAbility: 'reports.task-distribution.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: TaskDistributionReportSettingsEdit
                },
                {
                    path: 'work-report/employee',
                    name: 'reports.work-report.employee-report',
                    meta: {
                        requiredAbility: 'reports.work-report'
                    },
                    props: true,
                    component: EmployeeWorkReport
                },
                {
                    path: 'work-report/project',
                    name: 'reports.work-report.task-report',
                    meta: {
                        requiredAbility: 'reports.work-report'
                    },
                    props: true,
                    component: ProjectWorkReport
                },
                {
                    path: 'ratio-report/config',
                    name: 'reports.ratio-report.config',
                    component: RatioReportConfig,
                    meta: {
                        requiredAbility: 'reports.ratio-report.view'
                    },
                    props: (route) => ({
                        projectKeys: route.query.projects,
                        resultMode: route.query.result_mode,
                        setting: route.query.setting,
                        dateStart: route.query.date_start,
                        dateEnd: route.query.date_end
                    })
                },
                {
                    path: 'ratio-report/report',
                    name: 'reports.ratio-report.report',
                    component: RatioReportReport,
                    meta: {
                        requiredAbility: 'reports.ratio-report.view'
                    },
                    props: (route) => ({
                        projectKeys: route.query.projects,
                        resultMode: route.query.result_mode,
                        setting: route.query.setting,
                        dateStart: route.query.date_start,
                        dateEnd: route.query.date_end
                    })
                },
                {
                    path: 'ratio-report/report-settings',
                    name: 'reports.ratio-report.report-settings.index',
                    meta: {
                        requiredAbility: 'reports.ratio-report.manage'
                    },
                    component: RatioReportSettingsIndex
                },
                {
                    path: 'ratio-report/report-settings/create',
                    name: 'reports.ratio-report.report-settings.create',
                    meta: {
                        requiredAbility: 'reports.ratio-report.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: RatioReportSettingsCreate
                },
                {
                    path: 'ratio-report/report-settings/:setting_key/edit',
                    name: 'reports.ratio-report.report-settings.edit',
                    meta: {
                        requiredAbility: 'reports.ratio-report.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: RatioReportSettingsEdit
                }
            ]
        },
        {
            path: '/rma',
            component: FullLayout,
            children: [
                {
                    path: '',
                    name: 'rma.index',
                    meta: {
                        requiredAbility: 'projects.rma.menu'
                    },
                    props: true,
                    component: RmaIndex
                },
                {
                    path: 'create',
                    name: 'rma.create',
                    meta: {
                        requiredAbility: 'projects.rma.create',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: RmaCreate
                },
                {
                    path: ':rma_secret_key/edit',
                    name: 'rma.edit',
                    meta: {
                        requiredAbility: 'projects.rma.edit',
                        leaveConfirmation: false,
                        keepScrollPosition: true
                    },
                    props: true,
                    component: RmaEdit
                },
                {
                    path: ':rma_secret_key/:tab_name?',
                    name: 'rma.show',
                    meta: {
                        requiredAbility: 'projects.rma.menu',
                        leaveConfirmation: false,
                        keepScrollPosition: true
                    },
                    props: true,
                    component: RmaShow
                }
            ]
        },
        {
            path: '/tasks',
            component: FullLayout,
            children: [
                {
                    path: '',
                    name: 'tasks.index',
                    props: true,
                    component: TasksTaskIndex
                },
                {
                    path: 'create',
                    name: 'tasks.create',
                    meta: {
                        requiredAbility: 'projects.tasks.create',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: TasksTaskCreate
                },
                {
                    path: 'create-another',
                    name: 'tasks.create-another',
                    props: true,
                    component: TasksTaskCreateAnother
                },
                {
                    path: ':task_id/edit',
                    name: 'tasks.edit',
                    meta: {
                        requiredAbility: 'projects.tasks.edit',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: TasksTaskEdit
                },
                {
                    path: ':task_id/:tab_name?',
                    name: 'tasks.show',
                    meta: {
                        leaveConfirmation: false,
                        keepScrollPosition: true
                    },
                    props: true,
                    component: TasksTaskShow
                }
            ]
        },
        {
            path: '/duties',
            component: FullLayout,
            meta: {
                requiredAbility: 'duties.menu'
            },
            children: [
                {
                    path: ':duty_id?/duties',
                    name: 'duties',
                    meta: {
                        requiredAbility: 'duties.menu'
                    },
                    props: true,
                    component: Duty
                },
                {
                    path: 'create',
                    name: 'duties.create',
                    meta: {
                        leaveConfirmation: true,
                        submit: false,
                        requiredAbility: 'duties.create'
                    },
                    props: true,
                    component: DutyCreate
                },
                {
                    path: ':duty_id/edit',
                    name: 'duties.edit',
                    meta: {
                        leaveConfirmation: true,
                        submit: false,
                        requiredAbility: 'duties.create'
                    },
                    props: true,
                    component: DutyCreate
                },
                {
                    path: 'users',
                    name: 'users',
                    meta: {
                        requiredAbility: 'duties.menu'
                    },
                    props: true,
                    component: Duty
                },
                {
                    path: 'calendar',
                    name: 'calendar',
                    meta: {
                        requiredAbility: 'duties.menu'
                    },
                    props: true,
                    component: Duty
                },
                {
                    path: ':duty_id/share',
                    name: 'duties.share',
                    meta: {
                        leaveConfirmation: true,
                        submit: false,
                        requiredAbility: 'duties.menu'
                    },
                    props: true,
                    component: DutyShare
                }
            ]
        },
        {
            path: '/documentations',
            component: FullLayout,
            children: [
                {
                    path: '',
                    name: 'documentations.index',
                    component: DocumentationsIndex
                },
                {
                    path: 'create',
                    name: 'documentations.create',
                    meta: {
                        requiredAbility: 'documentations.manage_documentations',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: DocumentationsCreate
                },
                {
                    path: ':documentation_secret_key/edit',
                    name: 'documentations.edit',
                    meta: {
                        requiredAbility: 'documentations.manage_documentations',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: DocumentationsCreate
                }
            ]
        },
        {
            path: '/contacts',
            component: FullLayout,
            children: [
                {
                    path: '',
                    name: 'contacts.index',
                    component: ContactsContactIndex
                },
                {
                    path: 'create',
                    name: 'contacts.contact.create',
                    meta: {
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: ContactsContactCreate
                },
                {
                    path: 'invite-user',
                    name: 'contacts.contact.invite-user',
                    meta: {
                        requiredAbility: 'contacts.login.invite',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: ContactsInviteUser
                },
                {
                    path: ':contact_id',
                    name: 'contacts.contact.show',
                    redirect: '/contacts/:contact_id/details',
                    component: ContactsContactShow,
                    props: true,
                    children: [
                        {
                            path: 'details',
                            name: 'contacts.contact.partials.show.detail-tab',
                            props: true,
                            component: ContactsContactDetailsTab
                        },
                        {
                            path: 'addresses',
                            name: 'contacts.contact.partials.show.address-tab',
                            props: true,
                            component: ContactsContactAddressesTab
                        },
                        {
                            path: 'phones',
                            name: 'contacts.contact.partials.show.phone-tab',
                            props: true,
                            component: ContactsContactPhonesTab
                        },
                        {
                            path: 'emails',
                            name: 'contacts.contact.partials.show.email-tab',
                            props: true,
                            component: ContactsContactEmailsTab
                        },
                        {
                            path: 'login-data',
                            name: 'contacts.contact.partials.show.login-data-tab',
                            props: true,
                            component: ContactsContactLoginDataTab
                        },
                        {
                            path: 'staff-members',
                            name: 'contacts.contact.partials.show.staff-member-tab',
                            props: true,
                            component: ContactsContactStaffMemberTab
                        },
                        {
                            path: 'group-members',
                            name: 'contacts.contact.partials.show.group-member-tab',
                            props: true,
                            component: ContactsContactGroupMemberTab
                        },
                        {
                            path: 'groups',
                            name: 'contacts.contact.partials.show.group-tab',
                            props: true,
                            component: ContactsContactGroupsTab
                        },
                        {
                            path: 'absences',
                            name: 'contacts.contact.partials.show.absences-tab',
                            props: true,
                            component: ContactsContactAbsencesTab
                        },
                        {
                            path: 'pending-vacations',
                            name: 'contacts.contact.partials.show.pending-vacations-tab',
                            props: true,
                            component: ContactsContactPendingVacationsTab
                        },
                        {
                            path: 'settings',
                            name: 'contacts.contact.partials.show.setting-tab',
                            props: true,
                            component: ContactsContactSettingTab,
                            children: [
                                {
                                    path: 'widgets',
                                    name: 'contacts.contact.partials.show.settings.widget-tab',
                                    props: true,
                                    component: ContactsContactWidgetsTab
                                },
                                {
                                    path: 'accounting',
                                    name: 'contacts.contact.partials.show.settings.accounting-tab',
                                    props: true,
                                    component: ContactsContactAccountingTab
                                },
                                {
                                    path: 'status-information',
                                    name: 'contacts.contact.partials.show.settings.status-information-tab',
                                    props: true,
                                    component: ContactsContactStatusInformationTab
                                },
                                {
                                    path: 'overtime',
                                    name: 'contacts.contact.partials.show.settings.overtime-tab',
                                    props: true,
                                    component: ContactsContactOvertimeTab
                                }
                            ]
                        }
                    ]
                },
                {
                    path: ':contact_id/action',
                    redirect: '/contacts/:contact_id/details',
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    props: true,
                    children: [
                        {
                            path: 'edit',
                            name: 'contacts.contact.edit',
                            meta: {
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ContactsContactEdit
                        },
                        {
                            path: 'address/create',
                            name: 'contacts.address.create',
                            meta: {
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ContactsAddressCreate
                        },
                        {
                            path: 'phone/create',
                            name: 'contacts.phone.create',
                            meta: {
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ContactsPhoneCreate
                        },
                        {
                            path: 'email/create',
                            name: 'contacts.email.create',
                            meta: {
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ContactsEmailCreate
                        },
                        {
                            path: 'edit-login',
                            name: 'contacts.contact.edit-login',
                            meta: {
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ContactsContactEditLogin
                        },
                        {
                            path: 'send-new-password',
                            name: 'contacts.contact.send-new-password',
                            meta: {
                                requiredAbility: 'contacts.login.send_new_password'
                            },
                            props: true,
                            component: ContactsContactSendNewPassword
                        },

                        {
                            path: 'create',
                            name: 'contacts.contact.staff.create',
                            props: true,
                            component: ContactsContactCreate
                        },
                        {
                            path: 'manage-members',
                            name: 'contacts.contact.member.manage',
                            props: true,
                            component: ContactsContactGroupMembers
                        },
                        {
                            path: 'address/:address_id/edit',
                            name: 'contacts.address.edit',
                            meta: {
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ContactsAddressEdit
                        },
                        {
                            path: 'phone/:phone_id/edit',
                            name: 'contacts.phone.edit',
                            meta: {
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ContactsPhoneEdit
                        },
                        {
                            path: 'email/:email_id/edit',
                            name: 'contacts.email.edit',
                            meta: {
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ContactsEmailEdit
                        },
                        {
                            path: 'absence/create',
                            name: 'contacts.absence.create',
                            meta: {
                                requiredAbility: 'absences.create_absences',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: AbsencesAbsenceCreate
                        },
                        {
                            path: 'absence/:absence_id/edit',
                            name: 'contacts.absence.edit',
                            meta: {
                                requiredAbility: 'absences.create_absences',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: AbsencesAbsenceEdit
                        },
                        {
                            path: 'edit-vacation-entitlement/:year',
                            name: 'contacts.absence.edit-vacation-entitlement',
                            meta: {
                                requiredAbility: 'absences.manage_absences',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: AbsencesEditVacationEntitlement
                        },
                        {
                            path: 'overtime/create',
                            name: 'contacts.overtime.create',
                            meta: {
                                requiredAbility: 'contacts.overtime.manage',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ContactsOvertimeCreate
                        },
                        {
                            path: 'overtime/:overtime_id/edit',
                            name: 'contacts.overtime.edit',
                            meta: {
                                requiredAbility: 'contacts.overtime.manage',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ContactsOvertimeEdit
                        }
                    ]
                },
                {
                    path: ':contact_id/view',
                    name: 'contacts.contact.view',
                    props: true,
                    component: ContactsContactView
                }
            ]
        },
        {
            path: '/notification',
            component: FullLayout,
            meta: {
                requiredAbility: 'notification_settings.view'
            },
            children: [
                {
                    path: 'service-level-agreement',
                    name: 'notification.service-level-agreement.index',
                    meta: {
                        requiredAbility: 'notification_settings.view'
                    },
                    component: SlaIndex,
                    children: [
                        {
                            path: 'sla/configuration',
                            name: 'notification.service-level-agreement.configuration',
                            meta: {
                                requiredAbility: 'notification_settings.view'
                            },
                            component: SlaConfiguration
                        },
                        {
                            path: 'sla/date-view',
                            name: 'notification.service-level-agreement.date-view',
                            meta: {
                                requiredAbility: 'notification_settings.view'
                            },
                            component: SlaDateView
                        },
                        {
                            path: 'sla/settings',
                            name: 'notification.service-level-agreement.settings',
                            meta: {
                                requiredAbility: 'notification_settings.manage',
                                leaveConfirmation: true
                            },
                            component: SlaSettings
                        }
                    ]
                },
                {
                    path: 'service-level-agreement/create',
                    name: 'notification.service-level-agreement.create',
                    meta: {
                        requiredAbility: 'notification_settings.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: SlaConfigurationCreate
                },
                {
                    path: 'service-level-agreement/:configuration_secret/edit',
                    name: 'notification.service-level-agreement.edit',
                    meta: {
                        requiredAbility: 'notification_settings.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: SlaConfigurationEdit
                },
                {
                    path: 'service-level-agreement/:configuration_secret',
                    name: 'notification.service-level-agreement.show',
                    meta: {
                        requiredAbility: 'notification_settings.view'
                    },
                    props: true,
                    component: SlaConfigurationShow
                },
                {
                    path: 'sla/additional-shift-staff',
                    name: 'notification.service-level-agreement.additional-shift-staff',
                    meta: {
                        requiredAbility: 'notification_settings.manage_sla_date_view',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: (route) => ({
                        configurationKey: route.query.configuration,
                        date: route.query.date,
                        start: route.query.start,
                        end: route.query.end,
                        dayOfWeek: route.query.dayOfWeek || null,
                        absenceKey: route.query.absence || null
                    }),
                    component: SlaAdditionalShiftStaff
                },
                {
                    path: 'sla/date-view',
                    redirect: 'service-level-agreement/sla/date-view'
                },
                {
                    path: 'emergency',
                    name: 'notification.emergency',
                    meta: {
                        requiredAbility: 'notification_settings.view',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: EmergencyNotificationSettings
                }
            ]
        },
        {
            path: '/admin',
            component: FullLayout,
            meta: {
                requiredAbility: 'admin.menu'
            },
            children: [
                {
                    path: 'roles',
                    name: 'admin.roles.index',
                    meta: {
                        requiredAbility: 'admin.roles.edit'
                    },
                    component: AdminRolesIndex
                },
                {
                    path: 'roles/create/:type',
                    name: 'admin.roles.create',
                    meta: {
                        requiredAbility: 'admin.roles.edit',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: AdminRolesRoleCreate
                },
                {
                    path: 'roles/:role_id',
                    name: 'admin.roles.show',
                    meta: {
                        requiredAbility: 'admin.roles.edit'
                    },
                    props: true,
                    component: AdminRolesRoleShow
                },
                {
                    path: 'roles/:role_id/edit',
                    name: 'admin.roles.edit',
                    meta: {
                        requiredAbility: 'admin.roles.edit',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: AdminRolesRoleEdit
                },
                {
                    path: 'notification/emergency',
                    redirect: '/notification/emergency'
                },
                {
                    path: 'notification/service-level-agreement',
                    redirect: '/notification/service-level-agreement/sla/configuration'
                },
                {
                    path: 'notification/sla/date-view',
                    redirect: '/notification/service-level-agreement/sla/date-view'
                },
                {
                    path: 'contact/settings',
                    name: 'admin.contact.settings',
                    meta: {
                        requiredAbility: 'admin.contact_settings.manage',
                        leaveConfirmation: true
                    },
                    component: AdminContactSettings
                },
                {
                    path: 'system/settings',
                    name: 'admin.system.settings',
                    meta: {
                        requiredAbility: 'admin.system_settings.manage',
                        leaveConfirmation: true
                    },
                    component: AdminSystemSettings
                },
                {
                    path: 'system/public-holidays',
                    name: 'admin.system.public-holidays',
                    meta: {
                        requiredAbility: 'admin.system_settings.manage'
                    },
                    component: AdminSystemSettingsHolidays
                },
                {
                    path: 'system/create-holiday',
                    name: 'system.holiday.create',
                    meta: {
                        requiredAbility: 'absences.manage_absences',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: AdminSystemSettingsHolidayCreate
                },
                {
                    path: 'system/:absence_id/edit-holiday',
                    name: 'system.holiday.edit',
                    meta: {
                        requiredAbility: 'absences.manage_absences',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: AdminSystemSettingsHolidayEdit
                },
                {
                    path: 'system/maintenance',
                    name: 'admin.system.maintenance',
                    meta: {
                        requiredAbility: 'admin.maintenance_settings.manage'
                    },
                    component: AdminSystemSettingsMaintenance
                },
                {
                    path: 'task-settings',
                    name: 'admin.task-settings.index',
                    meta: {
                        requiredAbility: 'admin.task-workflows.edit'
                    },
                    component: TaskSettingsIndex
                },
                {
                    path: 'task-settings/:workflow/edit',
                    name: 'admin.task-settings.edit',
                    meta: {
                        requiredAbility: 'admin.task-workflows.edit',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: TaskSettingsEdit
                },
                {
                    path: 'task-settings/create',
                    name: 'admin.task-settings.create',
                    meta: {
                        requiredAbility: 'admin.task-workflows.edit',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: TaskSettingsCreate
                },
                {
                    path: 'task-types/:task_workflow/:task_type',
                    name: 'admin.task-types.edit',
                    meta: {
                        requiredAbility: 'admin.task-workflows.edit',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: TaskTypeEdit
                },
                {
                    path: 'task-types/:task_workflow',
                    name: 'admin.task-types.create',
                    meta: {
                        requiredAbility: 'admin.task-workflows.edit',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: TaskTypeCreate
                },
                {
                    path: 'project/settings',
                    name: 'admin.project.settings',
                    meta: {
                        requiredAbility: 'admin.project_settings.manage',
                        leaveConfirmation: true
                    },
                    component: AdminProjectSettings
                },
                {
                    path: 'rma-settings',
                    name: 'admin.rma-settings.index',
                    meta: {
                        requiredAbility: 'admin.rma_settings.manage'
                    },
                    component: RmaSettingsIndex
                },
                {
                    path: 'rma-settings/create-hardware-type',
                    name: 'rma.hardware-type.create',
                    meta: {
                        requiredAbility: 'admin.rma_settings.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: RmaSettingsHardwareTypeCreate
                },
                {
                    path: 'rma-settings/:hardware_type_id/edit-hardware-type',
                    name: 'rma.hardware-type.edit',
                    meta: {
                        requiredAbility: 'admin.rma_settings.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: RmaSettingsHardwareTypeEdit
                },
                {
                    path: 'global-notifications',
                    name: 'admin.global-notifications.index',
                    meta: {
                        requiredAbility: 'admin.global-notifications.manage'
                    },
                    component: GlobalNotificationsIndex
                },
                {
                    path: 'global-notifications/create',
                    name: 'admin.global-notifications.create',
                    meta: {
                        requiredAbility: 'admin.global-notifications.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: GlobalNotificationsCreate
                },
                {
                    path: 'global-notifications/:notification_secret/edit',
                    name: 'admin.global-notifications.edit',
                    meta: {
                        requiredAbility: 'admin.global-notifications.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: GlobalNotificationsEdit
                },
                {
                    path: 'tenant-systems',
                    name: 'admin.tenant-systems.index',
                    meta: {
                        requiredAbility: 'admin.tenant-systems.manage'
                    },
                    component: TenantSystemsIndex
                },
                {
                    path: 'translations',
                    redirect: '/admin/translations/models'
                },
                {
                    path: 'translations/models/:locale?',
                    name: 'admin.translations.models.index',
                    meta: {
                        requiredAbility: 'admin.translations.manage'
                    },
                    component: TranslationsModelIndex
                },
                {
                    path: 'translations/models/:locale/:model',
                    name: 'admin.translations.models.edit',
                    meta: {
                        requiredAbility: 'admin.translations.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: TranslationsModelEdit
                },
                {
                    path: 'tenants',
                    name: 'admin.tenants.index',
                    meta: {
                        requiredAbility: 'admin.tenants.invite'
                    },
                    component: TenantsIndex
                },
                {
                    path: 'tenants/invite',
                    name: 'admin.tenants.invite',
                    meta: {
                        requiredAbility: 'admin.tenants.invite',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: TenantsInvite
                },
                {
                    path: 'tenants/create',
                    name: 'admin.tenants.create',
                    meta: {
                        requiredAbility: 'admin.tenants.invite',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: TenantsCreate
                }
            ]
        },
        {
            path: '/projects',
            component: FullLayout,
            children: [
                {
                    path: '',
                    name: 'projects.index',
                    component: ProjectsProjectIndex
                },
                {
                    path: 'create',
                    name: 'projects.create',
                    meta: {
                        requiredAbility: 'projects.create',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: ProjectsProjectCreate
                },
                {
                    path: ':project_acronym',
                    redirect: '/projects/:project_acronym/details',
                    name: 'projects.show',
                    props: true,
                    component: ProjectsProjectShow,
                    children: [
                        {
                            path: 'details',
                            name: 'projects.partials.show.detail-tab',
                            props: true,
                            component: ProjectsProjectDetailTab
                        },
                        {
                            path: 'additional-details',
                            name: 'projects.partials.show.additional-detail-tab',
                            props: true,
                            component: ProjectsProjectAdditionalDetailTab
                        },
                        {
                            path: 'task-type-configuration',
                            name: 'projects.partials.show.task-type-configuration-tab',
                            meta: {
                                requiredAbility: 'projects.task_type_configurations.manage'
                            },
                            props: true,
                            component: ProjectsProjectTaskTypeConfigurationTab
                        },
                        {
                            path: 'manage-budgets',
                            name: 'projects.partials.show.manage-budget-tab',
                            meta: {
                                requiredAbility: 'projects.budgets.view'
                            },
                            props: true,
                            component: ProjectsProjectManageBudgetTab
                        },
                        {
                            path: 'manage-budgets-supplier',
                            name: 'projects.partials.show.manage-budget-supplier-tab',
                            meta: {
                                requiredAbility: 'projects.budgets.view'
                            },
                            props: true,
                            component: ProjectsProjectManageBudgetSupplierTab
                        },
                        {
                            path: 'movable_worklogs',
                            name: 'projects.partials.show.movable-worklogs-tab',
                            meta: {
                                requiredAbility: 'projects.manage_movable_worklogs_view'
                            },
                            props: true,
                            component: MovableWorklogsTab,
                        },
                        {
                            path: 'versions',
                            name: 'projects.partials.show.version-tab',
                            props: true,
                            component: ProjectsProjectVersionTab
                        },
                        {
                            path: 'files',
                            name: 'projects.partials.show.file-tab',
                            props: true,
                            component: ProjectsProjectFileTab
                        },
                        {
                            path: 'watchers',
                            name: 'projects.partials.show.watcher-tab',
                            props: true,
                            component: ProjectsProjectWatcherTab
                        },
                        {
                            path: 'external-costs',
                            name: 'projects.partials.show.external-cost-tab',
                            meta: {
                                requiredAbility: 'projects.external_costs.create'
                            },
                            props: true,
                            component: ProjectsProjectExternalCostTab
                        },
                        {
                            path: 'earnings-and-costs',
                            name: 'projects.partials.show.earnings-and-costs-tab',
                            meta: {
                                requiredAbility: 'projects.earnings_and_costs.view'
                            },
                            props: true,
                            component: ProjectsProjectEarningsAndCostsTab
                        },
                        {
                            path: 'planned-internal-external-costs',
                            name: 'projects.partials.show.planned-internal-external-costs-tab',
                            meta: {
                                requiredAbility: 'projects.planned_internal_external_costs.view'
                            },
                            props: true,
                            component: ProjectsProjectPlannedInternalExternalCostsTab
                        },
                        {
                            path: 'planned-earnings-and-costs',
                            name: 'projects.partials.show.planned-earnings-and-costs-tab',
                            meta: {
                                requiredAbility: 'projects.planned_earnings_and_costs.view'
                            },
                            props: true,
                            component: ProjectsProjectPlannedEarningsAndCostsTab
                        },
                        {
                            path: 'tags',
                            name: 'projects.partials.show.tag-tab',
                            props: true,
                            component: ProjectsProjectTagTab
                        },
                        {
                            path: 'history',
                            name: 'projects.partials.show.history-tab',
                            props: true,
                            component: ProjectsProjectHistoryTab
                        }
                    ]
                },
                {
                    path: ':project_acronym/action',
                    redirect: '/projects/:project_acronym/details',
                    props: true,
                    component: {
                        render(c) {
                            return c('router-view');
                        }
                    },
                    children: [
                        {
                            path: 'edit/:show_tab?',
                            name: 'projects.edit',
                            meta: {
                                requiredAbility: 'projects.edit',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectsProjectEdit
                        },
                        {
                            path: 'versions/create',
                            name: 'projects.versions.create',
                            meta: {
                                requiredAbility: 'projects.versions.manage',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectsVersionCreate
                        },
                        {
                            path: 'versions/:project_version_secret/edit',
                            name: 'projects.versions.edit',
                            meta: {
                                requiredAbility: 'projects.versions.manage',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectsVersionCreate
                        },
                        {
                            path: 'versions/:project_version_secret/release',
                            name: 'projects.version.release',
                            props: true,
                            component: ProjectsVersionRelease
                        },
                        {
                            path: 'files/create',
                            name: 'projects.files.create',
                            meta: {
                                requiredAbility: 'projects.files.manage',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectFileCreate
                        },
                        {
                            path: 'files/:file_secret/edit',
                            name: 'projects.files.edit',
                            meta: {
                                requiredAbility: 'projects.files.manage',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectFileCreate
                        },
                        {
                            path: 'external-costs/create',
                            name: 'projects.external-costs.create',
                            meta: {
                                requiredAbility: 'projects.external_costs.create',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectsExternalCostCreate
                        },
                        {
                            path: 'external-costs/create-planned',
                            name: 'projects.external-costs.create-planned',
                            meta: {
                                requiredAbility: 'projects.planned_internal_external_costs.view',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectsExternalCostCreatePlanned
                        },
                        {
                            path: 'external-costs/:external_cost_secret/edit',
                            name: 'projects.external-costs.edit',
                            meta: {
                                requiredAbility: 'projects.external_costs.create',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectsExternalCostEdit
                        },
                        {
                            path: 'external-costs/:external_cost_secret/edit-planned',
                            name: 'projects.external-costs.edit-planned',
                            meta: {
                                requiredAbility: 'projects.planned_internal_external_costs.view',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectsExternalCostEditPlanned
                        },
                        {
                            path: 'internal-costs/create',
                            name: 'projects.internal-costs.create',
                            meta: {
                                requiredAbility: 'projects.internal_costs.create',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectsPlannedInternalCostCreate
                        },
                        {
                            path: 'internal-costs/:internal_cost_secret/edit',
                            name: 'projects.internal-costs.edit',
                            meta: {
                                requiredAbility: 'projects.internal_costs.create',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectsPlannedInternalCostEdit
                        },
                        {
                            path: 'task-type-configurations/create',
                            name: 'projects.task-type-configurations.create',
                            meta: {
                                requiredAbility: 'projects.task_type_configurations.manage',
                                leaveConfirmation: true,
                                submit: false
                            },
                            props: true,
                            component: ProjectsTaskTypeConfigurationCreate
                        }
                    ]
                },
            ]
        },
        {
            path: '/project-planning',
            meta: {
                requiredAbility: 'projects.project_planning.menu'
            },
            component: FullLayout,
            children: [
                {
                    path: '',
                    name: 'project-planning.index',
                    meta: {
                        requiredAbility: 'projects.project_planning.menu'
                    },
                    component: ProjectPlanningIndex
                },
                {
                    path: ':project_acronym',
                    name: 'project-planning.show',
                    meta: {
                        requiredAbility: 'projects.project_planning.menu'
                    },
                    props: true,
                    component: ProjectPlanningShow
                }
            ]
        },
        {
            path: '/workload-planning',
            meta: {
                requiredAbility: 'projects.workload_planning.menu'
            },
            component: FullLayout,
            children: [
                {
                    path: '',
                    name: 'workload-planning.index',
                    meta: {
                        requiredAbility: 'projects.workload_planning.menu'
                    },
                    component: WorkloadPlanningIndex
                },
                {
                    path: ':contact_id',
                    name: 'workload-planning.show',
                    meta: {
                        requiredAbility: 'projects.workload_planning.menu'
                    },
                    props: true,
                    component: WorkloadPlanningShow
                }
            ]
        },
        {
            path: '/documents',
            meta: {
                requiredAbility: 'projects.documents.view'
            },
            component: FullLayout,
            children: [
                {
                    path: '',
                    name: 'documents.index',
                    meta: {
                        requiredAbility: 'projects.documents.view'
                    },
                    component: DocumentsIndex
                },
                {
                    path: 'create',
                    name: 'documents.create',
                    meta: {
                        requiredAbility: 'projects.documents.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: DocumentCreate
                },
                {
                    path: ':document_id/create-version',
                    name: 'documents.create_version',
                    meta: {
                        requiredAbility: 'projects.documents.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: DocumentCreateVersion
                }
            ]
        },
        {
            path: '/absences',
            component: FullLayout,
            meta: {
                requiredAbility: 'absences.create_absences'
            },
            children: [
                {
                    path: '',
                    name: 'absences.index',
                    meta: {
                        requiredAbility: 'absences.create_absences'
                    },
                    component: AbsencesIndex
                },
                // Fallback for old pending vacations urls
                {
                    path: 'company',
                    redirect: 'pending-vacations'
                },
                {
                    path: 'pending-vacations',
                    name: 'absences.pending.vacations',
                    component: AbsencesPendingVacationsRedirect
                },
                {
                    path: 'create',
                    name: 'absences.absence.create',
                    meta: {
                        requiredAbility: 'absences.create_absences',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: AbsencesAbsenceCreate
                },
                {
                    path: ':absence_id/edit',
                    name: 'absences.absence.edit',
                    meta: {
                        requiredAbility: 'absences.create_absences',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: AbsencesAbsenceEdit
                },
                {
                    path: 'edit-vacation-entitlement/:contact_id/:year',
                    name: 'absences.edit-vacation-entitlement',
                    meta: {
                        requiredAbility: 'absences.manage_absences',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: AbsencesEditVacationEntitlement
                }
            ]
        },
        {
            path: '/calendar',
            component: FullLayout,
            children: [
                {
                    path: '',
                    name: 'calendar.index',
                    component: Calendar
                }
            ]
        },
        {
            path: '/accounting',
            component: FullLayout,
            meta: {
                requiredAbility: 'accounting.menu'
            },
            children: [
                {
                    path: 'invoice-preparation',
                    name: 'accounting.invoice-preparation.index',
                    meta: {
                        requiredAbility: 'accounting.invoice_preparation'
                    },
                    component: InvoicePreparationIndex
                },
                {
                    path: 'invoice-preparation/create/:project_acronym',
                    name: 'accounting.invoice-preparation.create',
                    meta: {
                        requiredAbility: 'accounting.invoice_preparation',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: InvoicePreparationCreate
                },
                {
                    path: 'invoice-preparation/:invoice_id/edit',
                    name: 'accounting.invoice-preparation.edit',
                    meta: {
                        requiredAbility: 'accounting.invoice_preparation',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: InvoicePreparationEdit
                },
                {
                    path: 'prepared-invoices',
                    name: 'accounting.invoice-preparation.prepared-invoices',
                    meta: {
                        requiredAbility: 'accounting.invoice_preparation'
                    },
                    component: InvoicePreparationPreparedInvoices
                },
                {
                    path: 'invoice-issuing',
                    name: 'accounting.invoice-issuing.index',
                    meta: {
                        requiredAbility: 'accounting.invoice_issuing'
                    },
                    component: InvoiceIssuingIndex
                },
                {
                    path: 'invoice-issuing/:invoice_id/edit',
                    name: 'accounting.invoice-issuing.edit',
                    meta: {
                        requiredAbility: 'accounting.invoice_editing',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: InvoiceIssuingEdit
                },
                {
                    path: 'invoice-completion',
                    name: 'accounting.invoice-completion.index',
                    meta: {
                        requiredAbility: 'accounting.invoice_completion'
                    },
                    component: InvoiceCompletionIndex
                },
                {
                    path: 'invoice-completion/:invoice_id/upload',
                    name: 'accounting.invoice-completion.upload',
                    meta: {
                        requiredAbility: 'accounting.invoice_completion',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: InvoiceCompletionUploadOriginal
                },
                {
                    path: 'invoice-completion/create',
                    name: 'accounting.invoice-completion.create',
                    meta: {
                        requiredAbility: 'accounting.invoice_completion',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: InvoiceCompletionCreate
                },
                {
                    path: 'invoice-completion/:invoice_id/edit',
                    name: 'accounting.invoice-completion.edit',
                    meta: {
                        requiredAbility: 'accounting.invoice_editing',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: InvoiceCompletionEdit
                }
            ]
        },
        {
            path: '/telephone-list',
            component: FullLayout,
            meta: {
                requiredAbility: 'telephone_list.manage'
            },
            children: [
                {
                    path: 'list',
                    name: 'telephone-list.index',
                    meta: {
                        requiredAbility: 'telephone_list.manage'
                    },
                    component: TelephoneListIndex
                },
                {
                    path: 'history',
                    name: 'telephone-list.history',
                    meta: {
                        requiredAbility: 'telephone_list.manage'
                    },
                    component: TelephoneListHistory
                },
                {
                    path: 'create',
                    name: 'telephone-list.call.create',
                    meta: {
                        requiredAbility: 'telephone_list.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    component: TelephoneListCreate
                },
                {
                    path: ':call_id/edit',
                    name: 'telephone-list.call.edit',
                    meta: {
                        requiredAbility: 'telephone_list.manage',
                        leaveConfirmation: true,
                        submit: false
                    },
                    props: true,
                    component: TelephoneListEdit
                }
            ]
        }
    ]
});

router.beforeEach(beforEach);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js